























































import {
    isMobileLayout,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    defineComponent,
    computed,
} from '@vue/composition-api';

import { getIsTicketCheckVisible } from '@app/utils/config/sportConfig';
import { BetBuilderStore } from '@sportOfferFederation/bet-builder/store';

import BetBuilderSummary from './BetBuilderSummary.vue';
import BetBuilderSummaryCompact from './BetBuilderSummaryCompact.vue';
import BetBuilderSummaryErrorMessage from '../shared/components/BetBuilderSummaryErrorMessage.vue';
import { getFederationComponent } from '@src/federations/getFederationComponent';
import { useAnalytics } from '../store/composition/useAnalytics';

export default defineComponent({
    name: 'BetBuilderSummaryContainer',
    setup() {
        const stickyConfig = {
            scrollableContentSelector: '.bet-builder-summary',
            staticHigherContentSelector: '.verification-bar',
            fixedLowerContentSelector: '.ticket-stack__container .ss-chat',
            offset: 26,
        };
        const isMobile = computed(() => isMobileLayout());
        const isTicketCheckVisible = getIsTicketCheckVisible();
        const analytics = useAnalytics();
        const betBuilderStore = useVuexStore<BetBuilderStore>('data/betBuilder');

        const inactiveSelectionsCount = betBuilderStore.getter('inactiveSelectionsCount');
        const isSelectionInactive = betBuilderStore.getter('isSelectionInactive');
        const summaryDescription = betBuilderStore.getter('summaryDescription');
        const event = betBuilderStore.getter('event');
        const createBet = betBuilderStore.action('createBet');
        const clearUnavailableOdds = betBuilderStore.action('clearUnavailableOdds');
        const clearSelectedOdds = betBuilderStore.action('clearSelectedOdds');
        const isCreateOddInactive = betBuilderStore.getter('isCreateOddInactive');

        async function createOrClearBet() {
            // Copy the info to have it all until the end of the process!
            const analyticsPayload = {
                ...summaryDescription.value!,
            };

            if (isSelectionInactive.value) {
                analytics.unavailableOddsRemoved({
                    ...analyticsPayload,
                    numberOfRemoved: inactiveSelectionsCount.value,
                });
                return clearUnavailableOdds();
            } else {
                try {
                    analytics.addToBetslip(analyticsPayload);
                    const wasAddedToBetslip = await createBet();
                    if (wasAddedToBetslip) {
                        analytics.addToBetslipSucceeded(analyticsPayload);
                    }
                } catch {
                    // Error is ignorable, it was handled upstream, we just need to record this
                    analytics.addToBetslipFailed(analyticsPayload);
                }
            }
        }

        function clearSummary() {
            // Note: Needs to happen first so that we have all the info
            analytics.summaryCleared(summaryDescription.value!);
            clearSelectedOdds();
        }

        return {
            selectionsCount: betBuilderStore.getter('selectionsCount'),
            summary: betBuilderStore.getter('summary'),
            isDisabled: computed(() => isCreateOddInactive.value && !isSelectionInactive.value),
            clearError: betBuilderStore.action('clearError'),
            isCreateInProgress: betBuilderStore.getter('isBetCreateLoading'),
            isShowingError: betBuilderStore.getter('isShowingError'),
            isPreviewLoading: betBuilderStore.getter('isPreviewLoading'),
            inactiveSelectionsCount,
            stickyConfig,
            isMobile,
            isTicketCheckVisible,
            isSelectionInactive,
            title: computed(() => !event.value ? '' : `${event.value.team1Name} - ${event.value.team2Name}`),
            clearSummary,
            createOrClearBet,
        };
    },
    components: {
        BetBuilderSummary,
        BetBuilderSummaryCompact,
        BetBuilderSummaryErrorMessage,
        CheckTicket: getFederationComponent(() => import('tickets/CheckTicket')),
    },
});
